<script>
// import axios from "axios";
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import excel from "vue-excel-export";
import { ModelListSelect } from "vue-search-select";
Vue.use(excel);

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Items",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Fees Items",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees Items",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Item Name",
          sortable: true,
        },
        {
          key: "asset_account.acc_name",
          label: "Asset Account",
          sortable: true,
        },
        {
          key: "rev_account.acc_name",
          label: "Revenue Account",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        revAccount: "",
        assetAccount: "",
        year: new Date().getFullYear(),
      },
      deletePos: {
        name: "",
        id: "",
      },
      editPos: {
        name: "",
        revAccount: "",
        assetAccount: "",
        id: "",
      },
      existingItem: [],
      pageError: {
        nameError: "",
        revAccount: "",
        assetAccount: "",
      },
      modal: "",
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesItems", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("accounts", ["getAssetAccounts", "getRevenueAccounts"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FeesItems ? this.FeesItems.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesItems ? this.FeesItems.length : 1;
  },
  methods: {
    ...mapActions({
      FetchItems: "fees/fetchItems",
      AddItem: "fees/addItem",
      EditItem: "fees/editItem",
      DeleteItem: "fees/deleteItem",
      FilterItemsYear: "fees/filterItemsYear",
      FetchYears: "marks/fetchYear",
      FetchAssets: "accounts/fetchAssets",
      FetchRevenue: "accounts/fetchRevenue",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FeesItems ? this.FeesItems.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.pageError.nameError = "";
    },

    resetInputs() {
      this.data.name = "";
      this.editPos.name = "";
      this.editPos.id = "";
      this.resetError();
    },

    checkError() {},
    addItems() {
      if (this.data.name == "") {
        this.pageError.nameError = "Field can't be empty";
        return;
      } else {
        this.pageError.nameError = "";
      }
      if (this.editPos.id !== "") {
        //when editing item
        this.data.id = this.editPos.id;
        this.EditItem(this.data);
      } else {
        //when creating a new one
        if (this.data.assetAccount == "") {
          this.pageError.assetAccount = "Asset Account is required";
          return;
        } else {
          this.pageError.assetAccount = "";
        }
        if (this.data.revAccount == "") {
          this.pageError.revAccount = "Revenue Account is required";
          return;
        } else {
          this.pageError.revAccount = "";
        }
        //when adding item
        this.AddItem(this.data);
      }
      this.resetError();
      this.resetInputs();
    },
    filterItems() {
      this.FilterItemsYear(this.data);
    },
    editItem(values) {
      this.editPos.id = values.item.id;
      this.editPos.name = values.item.name;
      this.data.name = values.item.name;
    },
    showDeleteModal(values) {
      this.deletePos.id = values.item.id;
      this.deletePos.name = values.item.name;
    },
    deleteItems(modal) {
      this.modal = modal;
      this.DeleteItem(this.deletePos);
      this.closeModal(modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchItems();
    this.FetchYears();
    this.FetchAssets();
    this.FetchRevenue();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_items')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-md-4"
                v-if="
                  getCurrentUser.permissions.find((item) =>
                    item.permission.includes('add_fees_items')
                  )
                "
              >
                <h3 class="card-title text-primary">Fees Item Action</h3>
                <form @submit.prevent="addItems" class="m-2">
                  <div class="row d-flex">
                    <div class="form-group col-md-12 mb-3">
                      <label>Fees Item</label>
                      <input
                        required
                        type="text"
                        placeholder="Items Name e.g Fees, Development Fee, etc"
                        class="form-control"
                        @input="resetError"
                        v-model="data.name"
                      />
                      <span
                        class="text-danger"
                        v-if="pageError.nameError !== ''"
                        >{{ pageError.nameError }}</span
                      >
                    </div>
                    <div class="form-group mb-2">
                      <label>
                        Select Asset Account <br />
                        <small class="text-primary">
                          Its better you select under account receivable.
                        </small>
                      </label>
                      <model-list-select
                        required
                        :list="getAssetAccounts ? getAssetAccounts : []"
                        v-model="data.assetAccount"
                        option-value="id"
                        option-text="acc_name"
                        class="mb-2"
                        placeholder="Asset Account"
                      >
                      </model-list-select>
                      <span
                        class="text-danger"
                        v-if="pageError.assetAccount !== ''"
                        >{{ pageError.assetAccount }}</span
                      >
                    </div>
                    <div class="form-group mb-2">
                      <label>Select Revenue Account</label>
                      <model-list-select
                        required
                        :list="getRevenueAccounts ? getRevenueAccounts : []"
                        v-model="data.revAccount"
                        option-value="id"
                        option-text="acc_name"
                        class="mb-2"
                        placeholder="Revenue Account"
                      >
                      </model-list-select>
                      <span
                        class="text-danger"
                        v-if="pageError.revAccount !== ''"
                        >{{ pageError.revAccount }}</span
                      >
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      v-if="SaveStatus"
                      disabled
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                    >
                      <b-spinner
                        variant="priamry"
                        small
                        label="Spinning"
                      ></b-spinner>
                      Submitting...
                    </button>
                    <button
                      v-else
                      type="submit"
                      class="btn btn-sm btn-outline-primary"
                    >
                      <i class="fa fa-check"></i>
                      Submit Item
                    </button>
                  </div>
                </form>
              </div>
              <div class="row col-md-8" style="border-left: solid 1px #d6d0d0">
                <div class="row mb-4">
                  <div class="col-md-8 col-ms-6">
                    <h3 class="card-title text-primary mb-2">Fees Item List</h3>
                  </div>
                  <!-- <div class="col-md-4 col-ms-6">
                    <label for="">Filter Year</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="data.year"
                      @change="filterItems()"
                    >
                      <option
                        v-for="(schyear, index) in getYears"
                        :value="schyear.year"
                        :key="index"
                      >
                        {{ schyear.year }}
                      </option>
                    </select>
                  </div> -->
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->

                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    class="datatables"
                    :items="FeesItems"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(actions)="data">
                      <b-button-group>
                        <b-button
                          size="sm"
                          variant="primary"
                          v-b-modal.edit-Items-modal
                          @click="editItem(data)"
                          v-if="
                            getCurrentUser.permissions.find((item) =>
                              item.permission.includes('edit_fees_items')
                            )
                          "
                          ><i class="fa fa-edit"></i> Edit</b-button
                        >
                        <!-- <b-button
                          size="sm"
                          variant="danger"
                          v-b-modal.delete-Items-modal
                          @click="showDeleteModal(data)"
                          v-if="
                            getCurrentUser.permissions.find((item) =>
                              item.permission.includes('delete_fees_items')
                            )
                          "
                          ><i class="fa fa-trash"></i> Delete</b-button
                        > -->
                      </b-button-group>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal delete Items starts -->
      <b-modal
        id="delete-Items-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_fees_items')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Fees Item {{ deletePos.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Fees Item {{ deletePos.name }}? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-Items-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteItems('delete-Items-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
